@let isCellView = isCellView$ | async;
<div class="d-flex justify-content-between">
  <div class="d-flex flex-grow-1 date-picker-and-filter-wrapper">
    <div
      class="header-filter-box pe-0"
      [class.p-0]="!isViewOptionCardOpen"
      [class.ps-3]="isViewOptionCardOpen"
    >
      <wilson-shift-timeline-date-picker
        [isViewOptionCardOpen]="isViewOptionCardOpen"
        [ngClass]="
          isViewOptionCardOpen ? 'open-view-section me-3' : 'close-view-section'
        "
      ></wilson-shift-timeline-date-picker>

      <wilson-timeline-zoom-level
        [ngClass]="
          isViewOptionCardOpen ? 'open-view-section' : 'close-view-section'
        "
      ></wilson-timeline-zoom-level>

      @if (isViewOptionCardOpen) {
        <wilson-timeline-render-activities-toggle
          [ngClass]="
            isViewOptionCardOpen ? 'open-view-section' : 'close-view-section'
          "
          [isCellView]="!!isCellView"
        ></wilson-timeline-render-activities-toggle>
      }

      @if (
        isViewOptionCardOpen &&
        (FeatureName.StayManagement | featurePure | async) &&
        ('timeline-stays-management' | featureFlagPure | async)
      ) {
        <wilson-timeline-render-stays-toggle
          [ngClass]="
            isViewOptionCardOpen ? 'open-view-section' : 'close-view-section'
          "
          [disabled]="!!isCellView"
        ></wilson-timeline-render-stays-toggle>
      }

      <div
        class="divider"
        [ngClass]="
          isViewOptionCardOpen
            ? 'open-view-section mx-3'
            : 'close-view-section mx-1'
        "
      ></div>

      @if (
        'portal-shift-timeline-kpi-setting-button' | featureFlagPure | async
      ) {
        <wilson-shift-timeline-kpi-setting-button></wilson-shift-timeline-kpi-setting-button>
      }

      <button
        nz-button
        class="my-auto ms-2"
        (click)="handleRefreshClick()"
        [ngClass]="
          isViewOptionCardOpen
            ? 'open-view-section px-2'
            : 'close-view-section p-0'
        "
      >
        <fa-icon [icon]="faSyncAlt"></fa-icon>
      </button>

      <div class="divider" [class.ms-3]="isViewOptionCardOpen"></div>
      <div
        data-test-id="wilson-shift-timeline-header:date-picker-and-filter-wrapper-collapse-button"
        class="collapse-button d-flex justify-content-center align-items-center cursor-pointer"
        (click)="toggleViewSection()"
        [ngClass]="
          isViewOptionCardOpen ? 'collapse-icon-left' : 'collapse-icon-right'
        "
      >
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </div>
      <div class="divider"></div>
    </div>

    <div class="header-filter-box p-0">
      <wilson-drag-drop-mode-action-bar
        [isActionCardOpen]="isActionCardOpen"
      ></wilson-drag-drop-mode-action-bar>
      <div class="divider"></div>
      <div
        data-test-id="wilson-shift-timeline-header:action-card-collapse-button"
        class="collapse-button d-flex justify-content-center align-items-center cursor-pointer"
        (click)="toggleActionCard()"
        [ngClass]="
          isActionCardOpen ? 'collapse-icon-left' : 'collapse-icon-right'
        "
      >
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </div>
      <div class="divider"></div>
    </div>

    <div class="header-filter-box p-0">
      <wilson-quick-creation-bar
        [isQuickCreationCardOpen]="isQuickCreationCardOpen"
      ></wilson-quick-creation-bar>

      <div class="divider"></div>

      <div
        data-test-id="wilson-shift-timeline-header:quick-creation-card-collapse-button"
        class="collapse-button d-flex justify-content-center align-items-center cursor-pointer"
        (click)="toggleQuickCreationCard()"
        [ngClass]="
          isQuickCreationCardOpen ? 'collapse-icon-left' : 'collapse-icon-right'
        "
      >
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </div>
      <div class="divider"></div>
    </div>
  </div>
  <div class="header-filter-box px-0">
    <div class="d-flex align-items-center h-100">
      <div class="divider"></div>
      <div
        data-test-id="wilson-shift-timeline-header:kpi-card-collapse-button"
        class="collapse-button d-flex justify-content-center align-items-center cursor-pointer"
        (click)="toggleKPICard()"
        [ngClass]="isKPICardOpen ? 'collapse-icon-right' : 'collapse-icon-left'"
      >
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </div>
      <div class="divider"></div>
      <wilson-timeline-header-kpi-section
        [isKPICardOpen]="isKPICardOpen"
      ></wilson-timeline-header-kpi-section>
    </div>
  </div>
</div>
